import React from "react";
import { GoDotFill } from "react-icons/go";
import { FaPhoneAlt } from "react-icons/fa";
import images from "../../Data/images"; // Adjust image path accordingly

const AboutPage = () => {
  return (
    <div className="text-gray-800">
      {/* Top Hero Section */}
      <div className="bg-[#c4122f] text-white py-16 px-6 md:px-20 flex flex-col md:flex-row justify-between items-center gap-6">
        <div>
          <h1 className="text-4xl font-bold mb-4">ABOUT US</h1>
          <p className="text-lg max-w-xl">
            Nationwide High-Quality Security Services
          </p>
        </div>
      </div>

      {/* Breadcrumb and Phone */}
      <div className="flex justify-between items-center py-4 px-6 md:px-20 border-b">
        <span className="text-sm text-gray-500">HOME / ABOUT US</span>
        <span className="flex items-center gap-2 text-sm text-gray-700">
          <FaPhoneAlt className="text-[#c4122f]" />
          +1 (416) 477-7692
        </span>
      </div>

      {/* Objectives & Uniform Quick Links */}
      <div className="py-6 px-6 md:px-20 flex flex-wrap gap-4">
        <a
          href="#objective"
          className="bg-[#c4122f] text-white py-2 px-4 rounded-lg hover:bg-red-700"
        >
          Objectives
        </a>
        <a
          href="#uniform"
          className="bg-[#c4122f] text-white py-2 px-4 rounded-lg hover:bg-red-700"
        >
          Equipment & Uniforms
        </a>
      </div>

      {/* Company Overview */}
      {/* About Argus Security */}
<section
  id="overview"
  className="py-16 px-6 md:px-20 grid md:grid-cols-2 gap-12 items-center"
>
  <div>
    <h2 className="text-3xl font-bold text-[#c4122f] mb-4">
      About Argus Security International
    </h2>

    <h3 className="text-xl font-semibold mb-2">
      Professional Security Services Across Ontario
    </h3>

    <p className="mb-4">
      Argus Security International provides professional security services
      designed to protect people, property, and assets across Ontario.
    </p>

    <p className="mb-4">
      Our team delivers reliable security solutions for commercial properties,
      residential communities, construction projects, retail environments, and
      private clients.
    </p>

    <p>
      Through a combination of trained security personnel, modern technology,
      and structured operational standards, Argus Security provides clients
      with dependable protection and peace of mind.
    </p>
  </div>

  <img
    src={images.s5}
    alt="Argus Security Team"
    className="rounded-xl shadow-lg"
  />
</section>


{/* Our Approach */}
<section className="py-16 px-6 md:px-20 bg-gray-50">
  <h2 className="text-3xl font-bold text-[#c4122f] mb-6">
    Our Approach to Security
  </h2>

  <p className="mb-6 max-w-4xl">
    Security today requires more than simply placing guards on site.
    Effective protection requires planning, visibility, accountability,
    and modern tools.
  </p>

  <p className="mb-4 font-semibold">
    At Argus Security International, we focus on:
  </p>

  <ul className="grid md:grid-cols-2 gap-3 list-disc list-inside">
    <li>Professional security personnel</li>
    <li>Visible deterrence against criminal activity</li>
    <li>Technology-supported reporting and monitoring</li>
    <li>Strong operational standards and supervision</li>
    <li>Reliable communication with clients</li>
  </ul>

  <p className="mt-6 max-w-4xl">
    This approach allows us to deliver security programs that are structured,
    professional, and effective.
  </p>
</section>


{/* Security Solutions */}
<section className="py-16 px-6 md:px-20 grid md:grid-cols-2 gap-12 items-center">

  <img
    src={images.s6}
    alt="Security Operations"
    className="rounded-xl shadow-lg"
  />

  <div>
    <h2 className="text-3xl font-bold text-[#c4122f] mb-6">
      Security Solutions for Every Environment
    </h2>

    <p className="mb-4">
      Argus Security provides a wide range of security services designed to
      meet the needs of different industries.
    </p>

    <p className="mb-4 font-semibold">Our services include:</p>

    <ul className="grid grid-cols-1 gap-2 list-disc list-inside">
      <li>Uniformed Security Guards</li>
      <li>Mobile Patrol Services</li>
      <li>Parking Enforcement & Compliance</li>
      <li>Concierge Security</li>
      <li>Construction Site Security</li>
      <li>Gatehouse Security</li>
      <li>CCTV & Access Control Installation</li>
      <li>Loss Prevention</li>
      <li>Fire Watch Services</li>
      <li>Executive Protection</li>
    </ul>

    <p className="mt-4">
      Our goal is to provide flexible and dependable security solutions
      tailored to the needs of each client and property.
    </p>
  </div>

</section>


{/* Technology Driven Protection */}
<section className="py-16 px-6 md:px-20 bg-gray-50">
  <h2 className="text-3xl font-bold text-[#c4122f] mb-6">
    Technology-Driven Protection
  </h2>

  <p className="mb-4 max-w-4xl">
    Argus integrates modern security technology with traditional security
    services to provide greater oversight and accountability.
  </p>

  <p className="mb-4 font-semibold">
    Our security operations utilize tools such as:
  </p>

  <ul className="grid md:grid-cols-2 gap-3 list-disc list-inside">
    <li>Digital incident reporting</li>
    <li>Surveillance camera systems</li>
    <li>Access control technology</li>
    <li>Patrol verification systems</li>
    <li>Remote monitoring capabilities</li>
  </ul>

  <p className="mt-6 max-w-4xl">
    This technology allows us to provide clear documentation, improved
    communication, and stronger operational control.
  </p>
</section>


{/* Commitment */}
<section className="py-16 px-6 md:px-20 text-center">
  <h2 className="text-3xl font-bold text-[#c4122f] mb-6">
    Our Commitment
  </h2>

  <p className="max-w-3xl mx-auto mb-6">
    At Argus Security International, we are committed to maintaining the
    highest standards of professionalism, reliability, and service.
  </p>

  <p className="max-w-3xl mx-auto mb-6">
    Every property and client we protect receives our full attention and
    dedication to maintaining a safe and secure environment.
  </p>

  <div className="bg-gray-100 py-6 px-6 rounded-xl max-w-3xl mx-auto">
    <p className="font-semibold text-lg">
      Our mission is simple:
    </p>

    <p className="mt-2">
      Deliver professional security services that protect people, property,
      and assets while maintaining trust and reliability with every client
      we serve.
    </p>
  </div>
</section>

      {/* Team Section */}
      {/* <section id="team" className="py-16 px-6 md:px-20 text-center">
        <h2 className="text-3xl font-semibold text-[#c4122f] mb-8">
          Our Management Team
        </h2>
        <div className="grid md:grid-cols-4 gap-8 text-sm text-gray-700">
          {[
            { name: "LUKE PRATT", role: "CEO & Founder" },
            { name: "MATTHEW SCHWARTZ", role: "Chief Financial Officer" },
            { name: "JOSEPH MURPHY", role: "Chief Operations Officer" },
            { name: "CHRIS MANSEN", role: "Special Advisor to the CEO" },
          ].map((member) => (
            <div
              key={member.name}
              className="p-4 border rounded-lg hover:shadow-md"
            >
              <h3 className="font-bold">{member.name}</h3>
              <p className="text-xs text-gray-500 mt-1">{member.role}</p>
            </div>
          ))}
        </div>
      </section> */}

      {/* Contact CTA */}
      <div className="py-12 bg-[#c4122f] text-white text-center">
        <h3 className="text-xl mb-4">Interested in Learning More?</h3>
        <a
          href="/contact"
          className="bg-white text-[#c4122f] px-6 py-2 rounded-lg font-semibold hover:bg-gray-100 transition"
        >
          CONTACT US TODAY
        </a>
      </div>
    </div>
  );
};

export default AboutPage;
